import React, { useState } from "react";
import * as S from "./styles.ts";
import Input from "../Inputs/Input/index.tsx";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { validationPatientSchema } from "../../schemas/validationSchema.ts";
import { Typography } from "@mui/material";
import { InputMaskEnum } from "../../enums/InputMask.ts";
import { Endereco } from "../../models/Endereco.ts";
import { Paciente } from "../../models/Paciente.ts";
import { Response } from "../../types/Api.ts";
import pacienteService from "../../services/pacienteService.ts";
import { useFeedback } from "../../contexts/FeedbackContext.tsx";
import Loading from "../Loading/index.tsx";
import { useNavigate } from "react-router-dom";
import EnderecoComponent from "../Endereco/index.tsx";
import { PacienteFormData } from "./type.ts";

type CadastroPacienteProps = {
  onAdd?: (data: any) => void;
};

const CadastroPaciente = ({ onAdd }: CadastroPacienteProps) => {
  const navigate = useNavigate();
  const { showFeedback } = useFeedback();
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    control,
    formState: { errors },
  } = useForm<PacienteFormData>({
    resolver: yupResolver(validationPatientSchema),
  });

  const createPaciente = (data: any): Paciente => {
    const endereco: Endereco = new Endereco(
      data.endereco.rua,
      data.endereco.bairro,
      data.endereco.cep,
      data.endereco.numero,
      data.endereco.cidade,
      data.endereco.uf
    );

    return new Paciente(
      0,
      data.nome,
      data.email,
      data.telefone,
      data.cpf,
      endereco
    );
  };

  const onSubmit = async (data: any) => {
    try {
      setIsLoading(true);
      const paciente: Paciente = createPaciente(data);

      if (data.cpf === "") delete paciente.cpf;

      const response: Response<Paciente> = await pacienteService.create(
        paciente
      );

      showFeedback(response.message, "success");
      if (onAdd) onAdd(response);
      else {
        navigate("/paciente/listagem");
      }
    } catch (error) {
      showFeedback(error.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <S.Form onSubmit={(e) => { e.stopPropagation(); handleSubmit(onSubmit)(e); }}>
      <S.InputGroup>
        <Input
          label="Nome*"
          variant="outlined"
          register={register("nome")}
          error={errors.nome}
          helperText={errors.nome?.message}
        />
        <Input
          label="CPF"
          variant="outlined"
          register={register("cpf")}
          error={errors.cpf}
          helperText={errors.cpf?.message}
          format={InputMaskEnum.CPF}
        />
        <Input
          label="E-mail"
          variant="outlined"
          register={register("email")}
          error={errors.email}
          helperText={errors.email?.message}
        />
        <Input
          label="Telefone"
          register={register("telefone")}
          error={errors.telefone}
          helperText={errors.telefone?.message}
          format={InputMaskEnum.BrazilPhone}
        />
      </S.InputGroup>

      <Typography variant="h6" gutterBottom sx={{ color: "var(--ink)" }}>
        Endereço
      </Typography>
      <EnderecoComponent<PacienteFormData>
        register={register}
        errors={errors}
        setValue={setValue}
        getValues={getValues}
        control={control}
      />

      <S.SubmitButton variant="contained" color="primary" type="submit">
        {isLoading ? <Loading color="white" /> : "Cadastrar"}
      </S.SubmitButton>
    </S.Form>
  );
};

export default CadastroPaciente;
